import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";

import { Split } from "../components/admin/charts";
import { Box, bytes, Grid, Pending, Table } from "../components/admin/retro";
import { MachineBox, PipelineBox, ProvidersBox, QueuesBox } from "../components/admin/system";
import { adminSystemQuery } from "../lib/queries";

export const Route = createFileRoute("/_authed/admin/systeme")({
  component: SystemPage,
});

function SystemPage() {
  const system = useQuery(adminSystemQuery);
  if (!system.data) return <Pending query={system} />;
  return (
    <Grid>
      <MachineBox system={system.data} />
      <QueuesBox system={system.data} className="xl:col-span-2" />
      <ProvidersBox system={system.data} />
      <PipelineBox system={system.data} />
      <Box title="postgres" right="tables les plus lourdes" className="xl:col-span-2">
        <div className="mb-2">
          <Split
            parts={system.data.postgres.tables.slice(0, 6).map((table) => ({
              label: table.name,
              values: [table.bytes],
            }))}
          />
        </div>
        <Table
          head={["table", "taille", "lignes≈"]}
          rows={system.data.postgres.tables.map((table) => [
            table.name,
            bytes(table.bytes),
            Math.round(table.rows),
          ])}
        />
      </Box>
    </Grid>
  );
}
